import { AuditableModel } from '../../../Common/Misc/models/auditable.model';
import { SavedMentionSearchListItemApiModel } from '../../../api/mentions/model/saved-mention-search-list-item-api.model';
import { SavedSearchType } from '../../../Common/MonitorShared/enum/saved-search-type.enum';
import { LeftSidebarListItemConvertableModel } from '../../../Common/Layout/models/left-sidebar-list-item-convertable.model';
import { LeftSidebarListItemButton } from '../../../Common/Layout/models/left-sidebar-list-item-button.model';
import { LeftSidebarListItem } from '../../../Common/Layout/models/left-sidebar-list-item.model';
import { ActionsEnum } from '../../../Common/Basic/enums/actions.enum';
import { QuotaUsageIndicatorEnum } from '../enums/quota-usage-indicator.enum';

export class MentionSearchListItemModel implements AuditableModel, LeftSidebarListItemConvertableModel {
    id: number;
    name: string;
    createdByUserId?: number;
    createdDate?: Date;
    modifiedByUserId?: number;
    modifiedDate?: Date;

    applyTagIds: number[];
    type: SavedSearchType;
    hidden?: boolean;
    autoTaggingSearch?: boolean;
    groupId: number;
    isFavorite: boolean = false;
    autoSavingEnabled?: boolean;
    usageIndicator?: QuotaUsageIndicatorEnum;

    constructor(apiModel: SavedMentionSearchListItemApiModel, type: SavedSearchType = SavedSearchType.MONITORING) {
        this.id = +apiModel.id;
        this.type = type;
        this.name = apiModel.name;
        this.applyTagIds = apiModel.applyTagIds || [];
        this.createdByUserId = apiModel.createdByUserId;
        this.createdDate = new Date(apiModel.createdDate);
        this.modifiedByUserId = apiModel.lastModifiedByUserId;
        this.modifiedDate = apiModel.lastModifiedDate ? new Date(apiModel.lastModifiedDate) : null;
        this.hidden = apiModel.hidden;
        this.autoTaggingSearch = apiModel.autoTaggingSearch;
        this.groupId = apiModel.displayGroupId;
        this.isFavorite = apiModel.isFavorited;
        this.autoSavingEnabled = apiModel.savingEnabled;
        this.usageIndicator = apiModel.usageIndicator;
    }

    toLeftSidebarListItem(buttons?: LeftSidebarListItemButton[]): LeftSidebarListItem {
        // Use last modified date if it has a value, if not use created date
        const modifiedDate: Date = ((this.modifiedDate) ? this.modifiedDate : this.createdDate);
        const modifiedDateValue: number = modifiedDate.valueOf();
        let tagIcon;
        let indicator: string = '';
        let indicatorTooltip: string = '';

        if (this.hidden) {
            buttons = buttons.filter(button => button.key !== ActionsEnum.hide);
        } else {
            buttons = buttons.filter(button => button.key !== ActionsEnum.show);
        }

        if (this.applyTagIds && this.applyTagIds.length > 0) {
            tagIcon = this.autoTaggingSearch ? 'fa-solid fa-tag' : 'fa-kit fa-agpr-tag-demand';
        }

        if (this.isFavorite) {
            buttons = buttons.filter(button => button.key !== ActionsEnum.favorite);
        } else {
            buttons = buttons.filter(button => button.key !== ActionsEnum.unfavorite);
        }

        switch(this.usageIndicator) {
            case QuotaUsageIndicatorEnum.SAFE:
                indicator = 'fa-regular fa-scrubber';
                indicatorTooltip = `Monitor.leftSidebar.quotaUsageIndicator.${QuotaUsageIndicatorEnum.SAFE}`;
                break;
            case QuotaUsageIndicatorEnum.HIGH:
                indicator = 'fak fa-agpr-circle-high agpr-leftSidebarItems-itemIcon-warning';
                indicatorTooltip = `Monitor.leftSidebar.quotaUsageIndicator.${QuotaUsageIndicatorEnum.HIGH}`;
                break;
            case QuotaUsageIndicatorEnum.EXCESSIVE:
                indicator = 'fa-solid fa-circle-exclamation agpr-leftSidebarItems-itemIcon-warning';
                indicatorTooltip = `Monitor.leftSidebar.quotaUsageIndicator.${QuotaUsageIndicatorEnum.EXCESSIVE}`;
                break;
        }

        const item: LeftSidebarListItem = {
            value: this.id,
            label: this.name,
            icon: tagIcon,
            indicator,
            indicatorTooltip,
            // setting status to empty string until logic for correct value is implemented
            status: '', // mockMentionCount,
            buttons: buttons,
            lastModifiedDate: modifiedDateValue,
            groupId: this.groupId,
            isFavorite: this.isFavorite
        };

        return item;
    }
}
